var ___EXPOSE_LOADER_IMPORT___ = require("-!../../../node_modules/esbuild-loader/dist/index.cjs??clonedRuleSet-3.use[1]!./dcjspage_Faq.ts");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
___EXPOSE_LOADER_GLOBAL_THIS___["global"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
